import i18n from "~/i18n/i18n";

const VALIDATION_KEY_PREFIX = "common:grid.conditionalFormatting.validation";

const verifyFormattingRule = (rule: GridFormattingRule): string[] => {
	const errors: string[] = [];
	if (!rule.ruleType) {
		errors.push(i18n.t(`${VALIDATION_KEY_PREFIX}.ruleTypeRequired`));
	}
	for (let i = 0; i < rule.conditions.length; i++) {
		const condition = rule.conditions[i];
		const number = i + 1;
		if (condition.column === "" || !condition.dataType) {
			errors.push(i18n.t(`${VALIDATION_KEY_PREFIX}.columnAndDataTypeRequired`, { number }));
		}
		if (rule.ruleType === "value" && !condition.value) {
			errors.push(i18n.t(`${VALIDATION_KEY_PREFIX}.valueRequired`, { number }));
		}
		if (condition.type?.[condition.dataType] === "between" && !condition.value2) {
			errors.push(i18n.t(`${VALIDATION_KEY_PREFIX}.secondValueRequired`, { number }));
		}
	}
	return errors;
};

export default verifyFormattingRule;
